export const PersonalWorkbenchRouting = {
  path: "/personal-workbench",
  name: "personal-workbench",
  meta: { title: "个人工作台", icon: "personal-workbench" },
  component: () => import("@/views/personal-workbench/index.vue"),
};
